import { Location } from '@prisma/client';
import React from 'react';

import { GetPublicationsReturnItemType } from '@/shared/types';
import { Tooltip } from '@/shared/ui';

interface PublicationInfoProps {
  publication: GetPublicationsReturnItemType;
  pet: GetPublicationsReturnItemType['pet'];
  isMobile: boolean;
  currentAddress: Location | undefined;
  currentUserEmail: string | null | undefined;
}

const PublicationInfo: React.FC<PublicationInfoProps> = ({
  publication,
  pet,
  isMobile,
  currentAddress,
  currentUserEmail
}) => {
  return (
    <>
      <div className="flex justify-between pt-2">
        <div className="inline-flex flex-wrap lg:flex-nowrap">
          <p className="text-blue-main truncate text-xl font-bold md:text-3xl dark:text-teal-300">
            {publication.price} {publication.currency}&nbsp;
          </p>
          <p className="text-blue-main content-center text-base font-bold md:text-sm dark:text-teal-300">
            {publication.isBargainingAppropriate ? 'Торг' : ''}
          </p>
        </div>
      </div>
      {pet.breed.length > 20 && !isMobile ? (
        <Tooltip alignment="left" text={pet.breed}>
          <p className="text-letters-black truncate text-base font-bold whitespace-nowrap md:text-2xl dark:text-white">
            {pet.breed === 'Другое' ? 'Без породы' : pet.breed}
          </p>
        </Tooltip>
      ) : (
        <p className="text-letters-black line-clamp-2 text-sm font-bold md:truncate md:text-2xl md:whitespace-nowrap dark:text-white">
          {pet.breed === 'Другое' ? 'Без породы' : pet.breed}
        </p>
      )}
      <p className="text-letters-black text-base md:text-xl dark:text-white">
        {pet.sex === 'мужской' ? 'Мальчик' : 'Девочка'}
      </p>
      <p className="text-letters-black line-clamp-2 pt-2 text-sm md:text-xl dark:text-white">
        {publication.description}
      </p>
      <p className="mt:mt-0 mt-1 text-xs md:text-base">
        {currentAddress ? null : currentUserEmail === publication.author?.email ? (
          <b className="text-xs font-bold text-red-600">
            Укажите адрес в профиле. Это повысит шансы в поиске.
          </b>
        ) : null}
      </p>
    </>
  );
};

export default PublicationInfo;
